package com.yendo.mx.models

import kotlinx.serialization.Serializable

@Serializable
data class Favorito(
    val id: String = "", // ID del Restaurante o Producto
    val tipo: String = "", // "RESTAURANTE" o "PRODUCTO"
    val fechaAgregado: Long = 0,
    val idRestauranteAsociado: String = "" // Si es un producto, necesitamos saber de qué restaurante es
)
